/**
 * функция подсчета количества предметов.
 * @param(trades)
 * @return (Number)
 * */
export const totalItems = trades => trades.reduce((count, trade) => count + trade.items.length, 0);
